export default "__VITE_ASSET__BIettRTu__"